// // // import React, { useState, useEffect } from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import Header from "../../components/ui/Header";
// // // import Sidebar from "../../components/ui/Sidebar";
// // // import Button from "../../components/ui/Button";
// // // import Icon from "../../components/AppIcon";
// // // import StepIndicator from "./components/StepIndicator";
// // // import MarketSelection from "./components/MarketSelection";
// // // import TradingModeSelection from "./components/TradingModeSelection";
// // // import TradingConditions from "./components/TradingConditions";
// // // import RiskManagement from "./components/RiskManagement";
// // // import BotPreview from "./components/BotPreview";
// // // import TradingStrategy from "./components/TradingStrategy";

// // // const BotCreationWizard = () => {
// // //   const navigate = useNavigate();
// // //   const [currentStep, setCurrentStep] = useState(1);
// // //   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
// // //   const [botConfig, setBotConfig] = useState({
// // //     market: "",
// // //     tradingMode: "",
// // //     conditions: {
// // //       entry: [],
// // //       exit: [],
// // //       stop: [],
// // //       take: [],
// // //     },
// // //     riskSettings: {
// // //       accountBalance: "10000",
// // //       leverage: "1",
// // //       positionSizeType: "percentage",
// // //       positionSize: "10",
// // //       maxLossPerTrade: "2",
// // //       dailyLossLimit: "500",
// // //       maxConsecutiveLosses: "5",
// // //       trailingStopLoss: false,
// // //       positionScaling: false,
// // //       emergencyStop: true,
// // //     },
// // //   });

// // //   const steps = [
// // //     {
// // //       id: 1,
// // //       title: "Market Selection",
// // //       description: "Choose trading market",
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "Select Strategy",
// // //       description: "Select a trading strategy",
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Trading Mode",
// // //       description: "Select strategy type",
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "Trading Conditions",
// // //       description: "Configure entry/exit rules",
// // //     },
// // //     // {
// // //     //   id: 5,
// // //     //   title: "Risk Management",
// // //     //   description: "Set position sizing & limits",
// // //     // },
// // //     // {
// // //     //   id: 6,
// // //     //   title: "Review & Save",
// // //     //   description: "Finalize configuration",
// // //     // },
// // //   ];

// // //   // Auto-save functionality
// // //   useEffect(() => {
// // //     const autoSaveTimer = setTimeout(() => {
// // //       localStorage.setItem("botWizardConfig", JSON.stringify(botConfig));
// // //     }, 1000);

// // //     return () => clearTimeout(autoSaveTimer);
// // //   }, [botConfig]);

// // //   // Load saved configuration on mount
// // //   useEffect(() => {
// // //     const savedConfig = localStorage.getItem("botWizardConfig");
// // //     if (savedConfig) {
// // //       try {
// // //         setBotConfig(JSON.parse(savedConfig));
// // //       } catch (error) {
// // //         console.error("Failed to load saved configuration:", error);
// // //       }
// // //     }
// // //   }, []);

// // //   const handleNext = () => {
// // //     if (currentStep < steps?.length) {
// // //       setCurrentStep(currentStep + 1);
// // //     }
// // //   };

// // //   const handlePrevious = () => {
// // //     if (currentStep > 1) {
// // //       setCurrentStep(currentStep - 1);
// // //     }
// // //   };

// // //   const handleStepClick = (stepNumber) => {
// // //     setCurrentStep(stepNumber);
// // //   };

// // //   const handleMarketSelect = (market) => {
// // //     setBotConfig((prev) => ({
// // //       ...prev,
// // //       market,
// // //       // Reset trading mode if switching from futures to spot
// // //       tradingMode:
// // //         market === "spot" &&
// // //         (prev?.tradingMode === "short-only" || prev?.tradingMode === "hedge")
// // //           ? ""
// // //           : prev?.tradingMode,
// // //     }));
// // //   };

// // //   const handleModeSelect = (mode) => {
// // //     setBotConfig((prev) => ({
// // //       ...prev,
// // //       tradingMode: mode,
// // //     }));
// // //   };

// // //   const handleConditionsChange = (conditions) => {
// // //     setBotConfig((prev) => ({
// // //       ...prev,
// // //       conditions,
// // //     }));
// // //   };

// // //   const handleRiskSettingsChange = (riskSettings) => {
// // //     setBotConfig((prev) => ({
// // //       ...prev,
// // //       riskSettings,
// // //     }));
// // //   };

// // //   const handleSave = () => {
// // //     // Save bot configuration
// // //     const savedBots = JSON.parse(localStorage.getItem("savedBots") || "[]");
// // //     const newBot = {
// // //       id: Date.now(),
// // //       name: `Custom Bot ${savedBots?.length + 1}`,
// // //       config: botConfig,
// // //       createdAt: new Date()?.toISOString(),
// // //       status: "draft",
// // //     };

// // //     savedBots?.push(newBot);
// // //     localStorage.setItem("savedBots", JSON.stringify(savedBots));

// // //     // Clear wizard config
// // //     localStorage.removeItem("botWizardConfig");

// // //     // Navigate to bot details
// // //     navigate("/bot-details", { state: { botId: newBot?.id } });
// // //   };

// // //   const handleBacktest = () => {
// // //     // Save current config and navigate to backtesting
// // //     localStorage.setItem("backtestConfig", JSON.stringify(botConfig));
// // //     navigate("/backtesting-engine");
// // //   };

// // //   const canProceed = () => {
// // //     switch (currentStep) {
// // //       case 1:
// // //         return botConfig?.market !== "";
// // //       case 2:
// // //         return botConfig?.tradingMode !== "";
// // //       case 3:
// // //         return (
// // //           botConfig?.conditions?.entry?.length > 0 &&
// // //           botConfig?.conditions?.exit?.length > 0
// // //         );
// // //       case 4:
// // //         return (
// // //           botConfig?.riskSettings?.accountBalance &&
// // //           botConfig?.riskSettings?.positionSize &&
// // //           botConfig?.riskSettings?.maxLossPerTrade
// // //         );
// // //       default:
// // //         return true;
// // //     }
// // //   };

// // //   const renderStepContent = () => {
// // //     switch (currentStep) {
// // //       case 1:
// // //         return (
// // //           <MarketSelection
// // //             selectedMarket={botConfig?.market}
// // //             onMarketSelect={handleMarketSelect}
// // //           />
// // //         );
// // //       case 2:
// // //         return (
// // //           <TradingStrategy
// // //             selectedMode={botConfig?.tradingMode}
// // //             onModeSelect={handleModeSelect}
// // //             selectedMarket={botConfig?.market}
// // //           />
// // //         );
// // //       case 3:
// // //         return (
// // //           <TradingModeSelection
// // //             selectedMode={botConfig?.tradingMode}
// // //             onModeSelect={handleModeSelect}
// // //             selectedMarket={botConfig?.market}
// // //           />
// // //         );
// // //       case 4:
// // //         return (
// // //           <TradingConditions
// // //             conditions={botConfig?.conditions}
// // //             onConditionsChange={handleConditionsChange}
// // //           />
// // //         );
// // //       // case 5:
// // //       //   return (
// // //       //     <RiskManagement
// // //       //       riskSettings={botConfig?.riskSettings}
// // //       //       onRiskSettingsChange={handleRiskSettingsChange}
// // //       //     />
// // //       //   );
// // //       // case 6:
// // //       //   return (
// // //       //     <BotPreview
// // //       //       botConfig={botConfig}
// // //       //       onSave={handleSave}
// // //       //       onBacktest={handleBacktest}
// // //       //     />
// // //       //   );
// // //       default:
// // //         return null;
// // //     }
// // //   };

// // //   return (
// // //     <div className="min-h-screen bg-background">
// // //       <div className="p-6">
// // //         {/* Page Header */}
// // //         <div className="mb-6">
// // //           <div className="flex items-center space-x-4 mb-4">
// // //             <Button
// // //               variant="ghost"
// // //               onClick={() => navigate("/dashboard")}
// // //               iconName="ArrowLeft"
// // //               iconPosition="left"
// // //             >
// // //               Back to Dashboard
// // //             </Button>
// // //           </div>

// // //           <div className="flex items-center justify-between">
// // //             <div>
// // //               <h1 className="text-3xl font-bold text-foreground">
// // //                 Bot Creation Wizard
// // //               </h1>
// // //               <p className="text-muted-foreground mt-1">
// // //                 Create a custom trading bot with step-by-step guidance
// // //               </p>
// // //             </div>

// // //             <div className="flex items-center space-x-2">
// // //               <div className="flex items-center space-x-2 text-sm text-muted-foreground">
// // //                 <Icon name="Save" size={16} />
// // //                 <span>Auto-saving...</span>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* Step Indicator */}
// // //         <StepIndicator
// // //           currentStep={currentStep}
// // //           totalSteps={steps?.length}
// // //           steps={steps}
// // //         />

// // //         {/* Step Content */}
// // //         <div className="bg-card border border-border rounded-xl p-6 mb-6">
// // //           {renderStepContent()}
// // //         </div>

// // //         {/* Navigation Controls */}
// // //         {currentStep < 5 && (
// // //           <div className="flex items-center justify-between">
// // //             <Button
// // //               variant="outline"
// // //               onClick={handlePrevious}
// // //               disabled={currentStep === 1}
// // //               iconName="ChevronLeft"
// // //               iconPosition="left"
// // //             >
// // //               Previous
// // //             </Button>

// // //             <div className="flex items-center space-x-4">
// // //               {/* Step Navigation Dots */}
// // //               <div className="hidden sm:flex items-center space-x-2">
// // //                 {steps?.map((step) => (
// // //                   <button
// // //                     key={step?.id}
// // //                     onClick={() => handleStepClick(step?.id)}
// // //                     className={`w-3 h-3 rounded-full trading-transition ${
// // //                       step?.id === currentStep
// // //                         ? "bg-primary"
// // //                         : step?.id < currentStep
// // //                         ? "bg-success"
// // //                         : "bg-border hover:bg-border-secondary"
// // //                     }`}
// // //                     title={step?.title}
// // //                   />
// // //                 ))}
// // //               </div>

// // //               <Button
// // //                 variant="default"
// // //                 onClick={handleNext}
// // //                 disabled={!canProceed()}
// // //                 iconName="ChevronRight"
// // //                 iconPosition="right"
// // //               >
// // //                 {currentStep === steps?.length - 1 ? "Review" : "Next"}
// // //               </Button>
// // //             </div>
// // //           </div>
// // //         )}

// // //         {/* Help Section */}
// // //         <div className="mt-8 bg-muted/50 border border-border rounded-lg p-6">
// // //           <div className="flex items-start space-x-4">
// // //             <Icon name="HelpCircle" size={24} className="text-primary mt-0.5" />
// // //             <div>
// // //               <h3 className="font-semibold text-foreground mb-2">Need Help?</h3>
// // //               <p className="text-muted-foreground text-sm mb-4">
// // //                 Creating your first trading bot can be complex. Our
// // //                 comprehensive guides and tutorials will help you understand each
// // //                 step of the process.
// // //               </p>
// // //               <div className="flex flex-wrap gap-2">
// // //                 <Button
// // //                   variant="ghost"
// // //                   size="sm"
// // //                   iconName="PlayCircle"
// // //                   iconPosition="left"
// // //                 >
// // //                   Video Tutorial
// // //                 </Button>
// // //                 <Button
// // //                   variant="ghost"
// // //                   size="sm"
// // //                   iconName="BookOpen"
// // //                   iconPosition="left"
// // //                 >
// // //                   Documentation
// // //                 </Button>
// // //                 <Button
// // //                   variant="ghost"
// // //                   size="sm"
// // //                   iconName="MessageCircle"
// // //                   iconPosition="left"
// // //                 >
// // //                   Get Support
// // //                 </Button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default BotCreationWizard;


// // // src/pages/BotCreationWizard.jsx
// // import React, { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import Button from "../../components/ui/Button";
// // import Icon from "../../components/AppIcon";
// // import StepIndicator from "./components/StepIndicator";
// // import MarketSelection from "./components/MarketSelection";
// // import TradingStrategy from "./components/TradingStrategy";
// // import TradingModeSelection from "./components/TradingModeSelection";
// // import TradingConditions from "./components/TradingConditions";

// // const BotCreationWizard = () => {
// //   const navigate = useNavigate();

// //   // States
// //   const [currentStep, setCurrentStep] = useState(1);
// //   const [selectedMainStrategy, setSelectedMainStrategy] = useState("");
// //   const [botConfig, setBotConfig] = useState({
// //     market: "",
// //     tradingMode: "",
// //     conditions: {
// //       entry: [],
// //       exit: [],
// //       stop: [],
// //       take: [],
// //     },
// //   });

// //   const steps = [
// //     { id: 1, title: "Market Selection", description: "Choose trading market" },
// //     { id: 2, title: "Select Strategy", description: "Select a trading strategy" },
// //     { id: 3, title: "Trading Mode", description: "Select strategy type" },
// //     { id: 4, title: "Trading Conditions", description: "Configure entry/exit rules" },
// //   ];

// //   // Auto-save to localStorage
// //   useEffect(() => {
// //     const timer = setTimeout(() => {
// //       localStorage.setItem(
// //         "botWizardConfig",
// //         JSON.stringify({ ...botConfig, selectedMainStrategy })
// //       );
// //     }, 1000);
// //     return () => clearTimeout(timer);
// //   }, [botConfig, selectedMainStrategy]);

// //   // Load saved config on mount
// //   useEffect(() => {
// //     const saved = localStorage.getItem("botWizardConfig");
// //     if (saved) {
// //       try {
// //         const data = JSON.parse(saved);
// //         setBotConfig(data);
// //         setSelectedMainStrategy(data.selectedMainStrategy || "");
// //       } catch (error) {
// //         console.error("Failed to load saved config:", error);
// //       }
// //     }
// //   }, []);

// //   // Handlers
// //   const handleMarketSelect = (market) => {
// //     setBotConfig((prev) => ({
// //       ...prev,
// //       market,
// //       tradingMode:
// //         market === "spot" &&
// //         (prev.tradingMode === "short-only" || prev.tradingMode === "hedge")
// //           ? ""
// //           : prev.tradingMode,
// //     }));
// //   };

// //   const handleStrategySelect = (strategy) => {
// //     setSelectedMainStrategy(strategy);
// //     setBotConfig((prev) => ({ ...prev, tradingMode: "" })); 
// //   };


// //   const handleModeSelect = (mode) => {
// //     setBotConfig((prev) => ({ ...prev, tradingMode: mode }));
// //   };

// //   const handleConditionsChange = (conditions) => {
// //     setBotConfig((prev) => ({ ...prev, conditions }));
// //   };

// //   const handleNext = () => {
// //     if (currentStep < steps.length) {
// //       setCurrentStep(currentStep + 1);
// //     }
// //   };

// //   const handlePrevious = () => {
// //     if (currentStep > 1) {
// //       setCurrentStep(currentStep - 1);
// //     }
// //   };

// //   const handleStepClick = (stepId) => {
// //     if (canProceedUpTo(stepId)) {
// //       setCurrentStep(stepId);
// //     }
// //   };

// //   // Validation
// //   const canProceed = () => {
// //     switch (currentStep) {
// //       case 1:
// //         return botConfig.market !== "";
// //       case 2:
// //         return selectedMainStrategy !== "";
// //       case 3:
// //         return botConfig.tradingMode !== "";
// //       case 4:
// //         return (
// //           botConfig.conditions.entry.length > 0 &&
// //           botConfig.conditions.exit.length > 0
// //         );
// //       default:
// //         return true;
// //     }
// //   };

// //   const canProceedUpTo = (targetStep) => {
// //     for (let i = 1; i < targetStep; i++) {
// //       if (!canProceedForStep(i)) return false;
// //     }
// //     return true;
// //   };

// //   const canProceedForStep = (step) => {
// //     switch (step) {
// //       case 1: return botConfig.market !== "";
// //       case 2: return selectedMainStrategy !== "";
// //       case 3: return botConfig.tradingMode !== "";
// //       default: return true;
// //     }
// //   };

// //   // Final API Call
// //   const handleCreateBot = async () => {
// //     const payload = {
// //       ApiID: ,
// //       Api_Name:,
// //       Symbol: ,
// //       bot_name: ,
// //       Mode: botConfig.tradingMode.toUpperCase().replace("-", "_"),
// //       Market_Type: botConfig.market.toUpperCase(),
// //       Exchange: ,
// //       Investment_Long: ,
// //       Investment_Short: ,
// //       Take_Profit_Long: ,
// //       Take_Profit_Short:,
// //       Stop_Loss_Long:,
// //       Stop_Loss_Short: ,
// //       leverage: ,
// //       Strategy_Name: selectedMainStrategy,
// //       TP_Type:,
// //     };

// //     try {
// //       const response = await apiUtils.post(
// //         "/bot/create_bot",
// //         { showToast: true }
// //       );

// //       const result = await response.json();
// //       console.log("Bot Created:", result);

// //       // Save locally
// //       const savedBots = JSON.parse(localStorage.getItem("savedBots") || "[]");
// //       const newBot = {
// //         id: Date.now(),
// //         name: payload.bot_name,
// //         config: { ...botConfig, selectedMainStrategy },
// //         createdAt: new Date().toISOString(),
// //         status: "active",
// //       };
// //       savedBots.push(newBot);
// //       localStorage.setItem("savedBots", JSON.stringify(savedBots));
// //       localStorage.removeItem("botWizardConfig");

// //       navigate("/bot-details", { state: { botId: newBot.id } });
// //     } catch (error) {
// //       console.error("API Error:", error);
// //       alert("Failed to create bot. Check console.");
// //     }
// //   };

// //   // Render Step Content
// //   const renderStepContent = () => {
// //     switch (currentStep) {
// //       case 1:
// //         return (
// //           <MarketSelection
// //             selectedMarket={botConfig.market}
// //             onMarketSelect={handleMarketSelect}
// //           />
// //         );
// //       case 2:
// //         return (
// //           <TradingStrategy
// //             selectedMainStrategy={selectedMainStrategy}
// //             onStrategySelect={handleStrategySelect}
// //           />
// //         );
// //       case 3:
// //         return (
// //           <TradingModeSelection
// //             selectedMode={botConfig.tradingMode}
// //             onModeSelect={handleModeSelect}
// //             selectedMarket={botConfig.market}
// //             selectedMainStrategy={selectedMainStrategy}
// //           />
// //         );
// //       case 4:
// //         return (
// //           <TradingConditions
// //             conditions={botConfig.conditions}
// //             onConditionsChange={handleConditionsChange}
// //           />
// //         );
// //       default:
// //         return null;
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-background">
// //       <div className="p-6 max-w-6xl mx-auto">
// //         {/* Header */}
// //         <div className="mb-6">
// //           <Button
// //             variant="ghost"
// //             onClick={() => navigate("/dashboard")}
// //             iconName="ArrowLeft"
// //             iconPosition="left"
// //           >
// //             Back to Dashboard
// //           </Button>

// //           <div className="flex items-center justify-between mt-4">
// //             <div>
// //               <h1 className="text-3xl font-bold text-foreground">
// //                 Bot Creation Wizard
// //               </h1>
// //               <p className="text-muted-foreground mt-1">
// //                 Create a custom trading bot with step-by-step guidance
// //               </p>
// //             </div>
// //             <div className="flex items-center space-x-2 text-sm text-muted-foreground">
// //               <Icon name="Save" size={16} />
// //               <span>Auto-saving...</span>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Step Indicator */}
// //         <StepIndicator
// //           currentStep={currentStep}
// //           totalSteps={steps.length}
// //           steps={steps}
// //           onStepClick={handleStepClick}
// //           canProceedTo={canProceedForStep}
// //         />

// //         {/* Main Content */}
// //         <div className="bg-card border border-border rounded-xl p-6 mb-6">
// //           {renderStepContent()}
// //         </div>

// //         {/* Navigation */}
// //         <div className="flex items-center justify-between">
// //           <Button
// //             variant="outline"
// //             onClick={handlePrevious}
// //             disabled={currentStep === 1}
// //             iconName="ChevronLeft"
// //             iconPosition="left"
// //           >
// //             Previous
// //           </Button>

// //           <div className="flex items-center space-x-4">
// //             <div className="hidden sm:flex items-center space-x-2">
// //               {steps.map((step) => (
// //                 <button
// //                   key={step.id}
// //                   onClick={() => handleStepClick(step.id)}
// //                   disabled={!canProceedUpTo(step.id)}
// //                   className={`w-3 h-3 rounded-full trading-transition ${
// //                     step.id === currentStep
// //                       ? "bg-primary"
// //                       : step.id < currentStep
// //                       ? "bg-success"
// //                       : "bg-border hover:bg-border-secondary"
// //                   }`}
// //                   title={step.title}
// //                 />
// //               ))}
// //             </div>

// //             {currentStep === steps.length ? (
// //               <Button
// //                 variant="default"
// //                 onClick={handleCreateBot}
// //                 disabled={!canProceed()}
// //               >
// //                 Create Bot
// //               </Button>
// //             ) : (
// //               <Button
// //                 variant="default"
// //                 onClick={handleNext}
// //                 disabled= {!canProceed()}
// //                 iconName="ChevronRight"
// //                 iconPosition="right"
// //               >
// //                 Next
// //               </Button>
// //             )}
// //           </div>
// //         </div>

// //         {/* Help Section*/}
// //         <div className="mt-8 bg-muted/50 border border-border rounded-lg p-6">
// //           <div className="flex items-start space-x-4">
// //             <Icon name="HelpCircle" size={24} className="text-primary mt-0.5" />
// //             <div>
// //               <h3 className="font-semibold text-foreground mb-2">Need Help?</h3>
// //               <p className="text-muted-foreground text-sm mb-4">
// //                 Creating your first trading bot can be complex. Our guides will help you.
// //               </p>
// //               <div className="flex flex-wrap gap-2">
// //                 <Button variant="ghost" size="sm" iconName="PlayCircle" iconPosition="left">
// //                   Video Tutorial
// //                 </Button>
// //                 <Button variant="ghost" size="sm" iconName="BookOpen" iconPosition="left">
// //                   Documentation
// //                 </Button>
// //                 <Button variant="ghost" size="sm" iconName="MessageCircle" iconPosition="left">
// //                   Get Support
// //                 </Button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default BotCreationWizard;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Button from "../../components/ui/Button";
// import Icon from "../../components/AppIcon";
// import StepIndicator from "./components/StepIndicator";
// import MarketSelection from "./components/MarketSelection";
// import TradingStrategy from "./components/TradingStrategy";
// import TradingModeSelection from "./components/TradingModeSelection";
// import TradingConditions from "./components/TradingConditions";
// import apiUtils from "utils/apiutils";

// const BotCreationWizard = () => {
//   const navigate = useNavigate();

//   const [currentStep, setCurrentStep] = useState(1);
//   const [selectedMainStrategy, setSelectedMainStrategy] = useState("");
//   const [botConfig, setBotConfig] = useState({
//     market: "",
//     tradingMode: "",
//     conditions: {
//       entry: [],
//       exit: [],
//       stop: [],
//       take: [],
//     },
//     // New fields for final submit
//     takeProfitLong: "",
//     takeProfitShort: "",
//     stopLossLong: "",
//     stopLossShort: "",
//     apiId: "",
//     apiName: "",
//     symbol: "",
//     bot_name: "",
//     exchange: "",
//     investment_long: "",
//     investment_short: "",
//     leverage: "",
//     tp_type: "",
//   });

//   const steps = [
//     { id: 1, title: "Market Selection", description: "Choose trading market" },
//     { id: 2, title: "Select Strategy", description: "Select a trading strategy" },
//     { id: 3, title: "Trading Mode", description: "Select strategy type" },
//     { id: 4, title: "Trading Conditions", description: "Configure entry/exit rules" },
//   ];

//   // Auto-save
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       localStorage.setItem(
//         "botWizardConfig",
//         JSON.stringify({ ...botConfig, selectedMainStrategy, currentStep })
//       );
//     }, 1000);
//     return () => clearTimeout(timer);
//   }, [botConfig, selectedMainStrategy, currentStep]);

//   // Load saved
//   useEffect(() => {
//     const saved = localStorage.getItem("botWizardConfig");
//     if (saved) {
//       try {
//         const data = JSON.parse(saved);
//         setBotConfig(data);
//         setSelectedMainStrategy(data.selectedMainStrategy || "");
//         setCurrentStep(data.currentStep || 1);
//       } catch (error) {
//         console.error("Failed to load saved config:", error);
//       }
//     }
//   }, []);

//   // Handlers
//   const handleMarketSelect = (market) => {
//     setBotConfig((prev) => ({
//       ...prev,
//       market,
//       tradingMode:
//         market === "spot" && ["short-only", "hedge"].includes(prev.tradingMode)
//           ? ""
//           : prev.tradingMode,
//     }));
//   };

//   const handleStrategySelect = (strategy) => {
//     setSelectedMainStrategy(strategy);
//     setBotConfig((prev) => ({ ...prev, tradingMode: "" }));
//   };

//   const handleModeSelect = (mode) => {
//     setBotConfig((prev) => ({ ...prev, tradingMode: mode }));
//   };

//   const handleConditionsChange = (conditions) => {
//     setBotConfig((prev) => ({ ...prev, conditions }));
//   };

//   const handleFinalFieldChange = (field, value) => {
//     setBotConfig((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleNext = () => {
//     if (currentStep < steps.length && canProceed()) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const handlePrevious = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const handleStepClick = (stepId) => {
//     if (canProceedUpTo(stepId)) {
//       setCurrentStep(stepId);
//     }
//   };

//   // Validation
//   const canProceed = () => {
//     switch (currentStep) {
//       case 1:
//         return botConfig.market !== "";
//       case 2:
//         return selectedMainStrategy !== "";
//       case 3:
//         return botConfig.tradingMode !== "";
//       case 4:
//         const { entry, stop, take } = botConfig.conditions;
//         const hasEntry = entry.length > 0 && entry.every(c => c.symbol && c.bot_name && c.exchange);
//         const hasStopTake = 
//           botConfig.takeProfitLong && 
//           botConfig.takeProfitShort && 
//           botConfig.stopLossLong && 
//           botConfig.stopLossShort;
//         return hasEntry && hasStopTake;
//       default:
//         return true;
//     }
//   };

//   const canProceedUpTo = (targetStep) => {
//     for (let i = 1; i < targetStep; i++) {
//       if (!canProceedForStep(i)) return false;
//     }
//     return true;
//   };

//   const canProceedForStep = (step) => {
//     switch (step) {
//       case 1: return botConfig.market !== "";
//       case 2: return selectedMainStrategy !== "";
//       case 3: return botConfig.tradingMode !== "";
//       default: return true;
//     }
//   };

//   // Final API Call
//   const handleCreateBot = async () => {
//     const entry = botConfig.conditions.entry[0] || {};

//     const payload = {
//       ApiID: entry.apiId || "",
//       Api_Name: entry.apiName || "",
//       Symbol: entry.symbol || "",
//       bot_name: entry.bot_name || "",
//       Mode: botConfig.tradingMode.toUpperCase().replace("-", "_"),
//       Market_Type: botConfig.market.toUpperCase(),
//       Exchange: entry.exchange || "",
//       Investment_Long: entry.investment_long || "",
//       Investment_Short: entry.investment_short || "",
//       Take_Profit_Long: botConfig.takeProfitLong,
//       Take_Profit_Short: botConfig.takeProfitShort,
//       Stop_Loss_Long: botConfig.stopLossLong,
//       Stop_Loss_Short: botConfig.stopLossShort,
//       leverage: entry.leverage || "",
//       Strategy_Name: selectedMainStrategy,
//       TP_Type: entry.tp_type || "",
//     };

//     try {
//       const response = await apiUtils.post("/bot/create_bot", payload, { showToast: true });
//       const result = await response.json();
//       console.log("Bot Created:", result);

//       // Save locally
//       const savedBots = JSON.parse(localStorage.getItem("savedBots") || "[]");
//       const newBot = {
//         id: Date.now(),
//         name: payload.bot_name,
//         config: { ...botConfig, selectedMainStrategy },
//         createdAt: new Date().toISOString(),
//         status: "active",
//       };
//       savedBots.push(newBot);
//       localStorage.setItem("savedBots", JSON.stringify(savedBots));
//       localStorage.removeItem("botWizardConfig");

//       navigate("/bot-details", { state: { botId: newBot.id } });
//     } catch (error) {
//       console.error("API Error:", error);
//       alert("Failed to create bot. Check console.");
//     }
//   };

//   const renderStepContent = () => {
//     switch (currentStep) {
//       case 1:
//         return <MarketSelection selectedMarket={botConfig.market} onMarketSelect={handleMarketSelect} />;
//       case 2:
//         return <TradingStrategy selectedMainStrategy={selectedMainStrategy} onStrategySelect={handleStrategySelect} />;
//       case 3:
//         return (
//           <TradingModeSelection
//             selectedMode={botConfig.tradingMode}
//             onModeSelect={handleModeSelect}
//             selectedMarket={botConfig.market}
//             selectedMainStrategy={selectedMainStrategy}
//           />
//         );
//       case 4:
//         return (
//           <TradingConditions
//             conditions={botConfig.conditions}
//             onConditionsChange={handleConditionsChange}
//             botConfig={botConfig}
//             onFinalFieldChange={handleFinalFieldChange}
//             onAutoNext={() => canProceed() && setCurrentStep(5)}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-background">
//       <div className="p-6 max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="mb-6">
//           <Button variant="ghost" onClick={() => navigate("/dashboard")} iconName="ArrowLeft" iconPosition="left">
//             Back to Dashboard
//           </Button>
//           <div className="flex items-center justify-between mt-4">
//             <div>
//               <h1 className="text-3xl font-bold text-foreground">Bot Creation Wizard</h1>
//               <p className="text-muted-foreground mt-1">Create a custom trading bot with step-by-step guidance</p>
//             </div>
//             <div className="flex items-center space-x-2 text-sm text-muted-foreground">
//               <Icon name="Save" size={16} />
//               <span>Auto-saving...</span>
//             </div>
//           </div>
//         </div>

//         <StepIndicator
//           currentStep={currentStep}
//           totalSteps={steps.length}
//           steps={steps}
//           onStepClick={handleStepClick}
//           canProceedTo={canProceedForStep}
//         />

//         <div className="bg-card border border-border rounded-xl p-6 mb-6">
//           {renderStepContent()}
//         </div>

//         <div className="flex items-center justify-between">
//           <Button variant="outline" onClick={handlePrevious} disabled={currentStep === 1} iconName="ChevronLeft" iconPosition="left">
//             Previous
//           </Button>

//           <div className="flex items-center space-x-4">
//             {currentStep === steps.length ? (
//               <Button variant="default" onClick={handleCreateBot} disabled={!canProceed()}>
//                 Create Bot
//               </Button>
//             ) : (
//               <Button
//                 variant="default"
//                 onClick={handleNext}
//                 disabled={!canProceed()}
//                 iconName="ChevronRight"
//                 iconPosition="right"
//               >
//                 Next
//               </Button>
//             )}
//           </div>
//         </div>

//         <div className="mt-8 bg-muted/50 border border-border rounded-lg p-6">
//           <div className="flex items-start space-x-4">
//             <Icon name="HelpCircle" size={24} className="text-primary mt-0.5" />
//             <div>
//               <h3 className="font-semibold text-foreground mb-2">Need Help?</h3>
//               <p className="text-muted-foreground text-sm mb-4">
//                 Creating your first trading bot can be complex. Our guides will help you.
//               </p>
//               <div className="flex flex-wrap gap-2">
//                 <Button variant="ghost" size="sm" iconName="PlayCircle" iconPosition="left">Video Tutorial</Button>
//                 <Button variant="ghost" size="sm" iconName="BookOpen" iconPosition="left">Documentation</Button>
//                 <Button variant="ghost" size="sm" iconName="MessageCircle" iconPosition="left">Get Support</Button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BotCreationWizard;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Icon from "../../components/AppIcon";
import StepIndicator from "./components/StepIndicator";
import MarketSelection from "./components/MarketSelection";
import TradingStrategy from "./components/TradingStrategy";
import TradingModeSelection from "./components/TradingModeSelection";
import TradingConditions from "./components/TradingConditions";
import apiUtils from "utils/apiutils";

const BotCreationWizard = () => {
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  console.log("cu", currentStep);

  const [selectedMainStrategy, setSelectedMainStrategy] = useState("");
  const [botConfig, setBotConfig] = useState({
    market: "",
    tradingMode: "",
    conditions: {
      entry: [],
      exit: [],
      stop: [],
      take: [],
    },
    takeProfitLong: "",
    takeProfitShort: "",
    stopLossLong: "",
    stopLossShort: "",
    apiId: "",
    apiName: "",
    symbol: "",
    bot_name: "",
    exchange: "",
    investment_long: "",
    investment_short: "",
    leverage: "",
    sl_type: "",
    subsequent_multiplier: "",
    tp_type: "",
  });

  const steps = [
    { id: 1, title: "Market Selection", description: "Choose trading market" },
    { id: 2, title: "Select Strategy", description: "Select a trading strategy" },
    { id: 3, title: "Trading Mode", description: "Select strategy type" },
    { id: 4, title: "Trading Conditions", description: "Configure entry/exit rules" },
  ];

  // ──────────────────────────────────────────────────────────────────────
  // 1. LOAD SAVED DATA ON MOUNT → START FROM SAVED STEP
  // ──────────────────────────────────────────────────────────────────────
  useEffect(() => {
    const saved = localStorage.getItem("botWizardConfig");
    if (saved) {
      try {
        const data = JSON.parse(saved);
        // Restore config
        setBotConfig((prev) => ({ ...prev, ...data }));
        // Restore strategy
        setSelectedMainStrategy(data.selectedMainStrategy || "");
        // **START FROM SAVED STEP**
        const savedStep = data.currentStep || 1;
        setCurrentStep(savedStep);
      } catch (error) {
        console.error("Failed to load saved config:", error);
      }
    }
    // Runs only once on mount
  }, []);

  // ──────────────────────────────────────────────────────────────────────
  // 2. AUTO-SAVE EVERY CHANGE (with 1s debounce)
  // ──────────────────────────────────────────────────────────────────────
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     localStorage.setItem(
  //       "botWizardConfig",
  //       JSON.stringify({ ...botConfig, selectedMainStrategy, currentStep })
  //     );
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, [botConfig, selectedMainStrategy, currentStep]);

  // ──────────────────────────────────────────────────────────────────────
  // HANDLERS
  // ──────────────────────────────────────────────────────────────────────
  const handleMarketSelect = (market) => {
    setBotConfig((prev) => ({
      ...prev,
      market,
      tradingMode:
        market === "spot" && ["short-only", "hedge"].includes(prev.tradingMode)
          ? ""
          : prev.tradingMode,
    }));
  };

  const handleStrategySelect = (strategy) => {
    setSelectedMainStrategy(strategy);
    setBotConfig((prev) => ({ ...prev, tradingMode: "" }));
  };

  const handleModeSelect = (mode) => {
    setBotConfig((prev) => ({ ...prev, tradingMode: mode }));
  };

  const handleConditionsChange = (conditions) => {
    setBotConfig((prev) => ({ ...prev, conditions }));
  };

  const handleFinalFieldChange = (field, value) => {
    setBotConfig((prev) => ({ ...prev, [field]: value }));
  };

  const handleNext = () => {
    if (currentStep < steps.length && canProceed()) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleStepClick = (stepId) => {
    if (canProceedUpTo(stepId)) {
      setCurrentStep(stepId);
    }
  };

  // ──────────────────────────────────────────────────────────────────────
  // VALIDATION
  // ──────────────────────────────────────────────────────────────────────
  const canProceed = () => {
    switch (currentStep) {
      case 1:
        return botConfig.market !== "";
      case 2:
        return selectedMainStrategy !== "";
      case 3:
        return botConfig.tradingMode !== "";
      case 4:
        const { entry } = botConfig.conditions;
        const hasEntry = entry.length > 0 && entry.every(c =>
          c.apiName && c.leverage && c.symbol && c.bot_name && c.exchange
        );
        const hasStopTake =
          botConfig.takeProfitLong &&
          botConfig.takeProfitShort &&
          botConfig.stopLossLong &&
          botConfig.stopLossShort;
        return hasEntry && hasStopTake;
      default:
        return true;
    }
  };

  const canProceedUpTo = (targetStep) => {
    for (let i = 1; i < targetStep; i++) {
      if (!canProceedForStep(i)) return false;
    }
    return true;
  };

  const canProceedForStep = (step) => {
    switch (step) {
      case 1: return botConfig.market !== "";
      case 2: return selectedMainStrategy !== "";
      case 3: return botConfig.tradingMode !== "";
      default: return true;
    }
  };

  const [apis, setApis] = useState([]);

  // ──────────────────────────────────────────────────────────────────────
  // 2. Fetch APIs once on mount
  // ──────────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchApis = async () => {
      const payload = { page_no: 1, page_size: 10000, market_type: [botConfig.market?.toUpperCase()] };
      try {
        const resp = await apiUtils.post("/api/view_api_details", payload, { showToast: false });
        if (resp?.Success) setApis(resp.Success);
      } catch (e) {
        console.error(e);
      }
    };
    fetchApis();
  }, [botConfig.market]);

  // ──────────────────────────────────────────────────────────────────────
  // FINAL API CALL
  // ──────────────────────────────────────────────────────────────────────
  const handleCreateBot = async () => {
    const entry = botConfig.conditions.entry[0] || {};

    // Find the human-readable name from the fetched `apis` list
    const selectedApi = apis.find(a => a.ApiID === entry.apiName);

    const payload = {
      ApiID: entry.apiName || "",
      Api_Name: selectedApi?.Api_Name || "",
      Symbol: entry.symbol.toUpperCase() || "",
      bot_name: entry.bot_name || "",
      Mode: botConfig.tradingMode.toUpperCase().replace("-", "_"),
      Market_Type: botConfig.market.toUpperCase(),
      Exchange: entry.exchange?.toUpperCase() || "",
      Investment_Long: Number(entry.investment_long || "") || 0,
      Investment_Short: Number(entry.investment_short || 0),
      Take_Profit_Long: Number(botConfig.takeProfitLong || 0),
      Take_Profit_Short: Number(botConfig.takeProfitShort) || 0,
      Stop_Loss_Long: Number(botConfig.stopLossLong) || 0,
      Stop_Loss_Short: Number(botConfig.stopLossShort) || 0,
      leverage: Number(entry.leverage || ""),
      Strategy_Name: selectedMainStrategy,
      SL_Type: entry.sl_type || "",
      Subsequent_Multiplier: Number(entry.subsequent_multiplier || 0),
      TP_Type: entry.tp_type || "",
    };


    try {
      const response = await apiUtils.post("/bot/create_bot", payload, { showToast: true });

      const newBot = response.Success;
      if (response?.Trade_Type === "PAPER") {
        navigate("/dashboard/paper-trading", { state: { botId: newBot.id } });
      } else {
        navigate("/dashboard/bot-analytics", { state: { botId: newBot.id } });
      }
      return newBot

      // // Save locally
      // const savedBots = JSON.parse(localStorage.getItem("savedBots") || "[]");
      // const newBot = {
      //   id: Date.now(),
      //   name: payload.bot_name,
      //   config: { ...botConfig, selectedMainStrategy },
      //   createdAt: new Date().toISOString(),
      //   status: "active",
      // };
      // savedBots.push(newBot);
      // localStorage.setItem("savedBots", JSON.stringify(savedBots));
      // localStorage.removeItem("botWizardConfig");

    } catch (error) {
      toast.error(error?.response?.data?.Error || "Failed to create bot.");
    }
  };

  // ──────────────────────────────────────────────────────────────────────
  // RENDER STEP CONTENT
  // ──────────────────────────────────────────────────────────────────────
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <MarketSelection selectedMarket={botConfig.market} onMarketSelect={handleMarketSelect} />;
      case 2:
        return <TradingStrategy selectedMainStrategy={selectedMainStrategy} onStrategySelect={handleStrategySelect} />;
      case 3:
        return (
          <TradingModeSelection
            selectedMode={botConfig.tradingMode}
            onModeSelect={handleModeSelect}
            selectedMarket={botConfig.market}
            selectedMainStrategy={selectedMainStrategy}
          />
        );
      case 4:
        return (
          <TradingConditions
            conditions={botConfig.conditions}
            onConditionsChange={handleConditionsChange}
            botConfig={botConfig}
            selectedMode={botConfig.tradingMode}
            selectedMainStrategy={selectedMainStrategy}
            onFinalFieldChange={handleFinalFieldChange}
            handleCreateBot={handleCreateBot}
            apis={apis}
          />
        );
      default:
        return null;
    }
  };

  // ──────────────────────────────────────────────────────────────────────
  // MAIN RENDER
  // ──────────────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen bg-background">
      <div className="p-6 max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <Button variant="ghost" onClick={() => navigate("/dashboard")} iconName="ArrowLeft" iconPosition="left">
            Back to Dashboard
          </Button>
          <div className="flex items-center justify-between mt-4">
            <div>
              <h1 className="text-3xl font-bold text-foreground">Bot Creation Wizard</h1>
              <p className="text-muted-foreground mt-1">Create a custom trading bot with step-by-step guidance</p>
            </div>

          </div>
        </div>

        <StepIndicator
          currentStep={currentStep}
          totalSteps={steps.length}
          steps={steps}
          onStepClick={handleStepClick}
          canProceedTo={canProceedForStep}
        />

        <div className="bg-card border border-border rounded-xl p-6 mb-6">
          {renderStepContent()}
        </div>

        <div className="flex items-center justify-between">
          <Button variant="outline" onClick={handlePrevious} disabled={currentStep === 1} iconName="ChevronLeft" iconPosition="left">
            Previous
          </Button>

          <div className="flex items-center space-x-4">
            {currentStep === steps.length ? (
              <Button variant="default" onClick={handleCreateBot} disabled={!canProceed()}>
                Create Bot
              </Button>
            ) : (
              <Button
                variant="default"
                onClick={handleNext}
                disabled={!canProceed()}
                iconName="ChevronRight"
                iconPosition="right"
              >
                Next
              </Button>
            )}
          </div>
        </div>

        <div className="mt-8 bg-muted/50 border border-border rounded-lg p-6">
          <div className="flex items-start space-x-4">
            <Icon name="HelpCircle" size={24} className="text-primary mt-0.5" />
            <div>
              <h3 className="font-semibold text-foreground mb-2">Need Help?</h3>
              <p className="text-muted-foreground text-sm mb-4">
                Creating your first trading bot can be complex. Our guides will help you.
              </p>
              <div className="flex flex-wrap gap-2">
                <Button variant="ghost" size="sm" iconName="PlayCircle" iconPosition="left">Video Tutorial</Button>
                <Button variant="ghost" size="sm" iconName="BookOpen" iconPosition="left">Documentation</Button>
                <Button variant="ghost" size="sm" iconName="MessageCircle" iconPosition="left">Get Support</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotCreationWizard;